.questionInputWrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
}

.questionInputContainer {
    border-radius: 8px;
    box-shadow:
        0px 8px 16px rgba(0, 0, 0, 0.14),
        0px 0px 2px rgba(0, 0, 0, 0.12);
    min-height: 90px;
    width: 100%;
    padding: 15px;
    background: white;
}

.questionInputTextArea {
    width: 100%;
    line-height: 40px;
}

.questionInputButtonsContainer {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 4px;
}

.filterButtonWrapper {
    position: relative;
    display: inline-flex;
}

.filterIndicator {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 8px;
    height: 8px;
    background-color: #d83b01;
    border-radius: 50%;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
    pointer-events: none;
}

.enhanceButtonLoading {
    opacity: 0.4;
    pointer-events: none;
}

.enhanceWarning {
    font-size: 12px;
    color: #d83b01;
    animation: fadeIn 0.2s ease-in;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.attachmentsRow {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 4px 2px;
}

.attachmentChip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #f0f0f0;
    border: 1px solid #d0d0d0;
    border-radius: 12px;
    padding: 2px 8px 2px 10px;
    font-size: 12px;
    max-width: 200px;
}

.chipName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 160px;
}

.chipRemove {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    color: #666;
    line-height: 1;
}

.chipRemove:hover {
    color: #d83b01;
}
